exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the User Evaluation module should live here.\n * Import as neede like so:\n * ...\n * import userEvaluationStyles from 'userEvaluationModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"user-evaluation-item\">\n * ...\n */\n\n.modules-userEvaluation-___userEvaluationModuleStyles__user-evaluation-item___yWYXi {\n\n}\n", ""]);

// exports
exports.locals = {
	"user-evaluation-item": "modules-userEvaluation-___userEvaluationModuleStyles__user-evaluation-item___yWYXi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/userEvaluation/userEvaluationModuleStyles.css
// module id = 1366
// module chunks = 1